/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkingTimeCost } from './WorkingTimeCost';
import {
    WorkingTimeCostFromJSON,
    WorkingTimeCostFromJSONTyped,
    WorkingTimeCostToJSON,
    WorkingTimeCostToJSONTyped,
} from './WorkingTimeCost';

/**
 * 
 * @export
 * @interface WorkingTimeCosts
 */
export interface WorkingTimeCosts {
    /**
     * 
     * @type {Array<WorkingTimeCost>}
     * @memberof WorkingTimeCosts
     */
    workingTimeCosts: Array<WorkingTimeCost>;
}

/**
 * Check if a given object implements the WorkingTimeCosts interface.
 */
export function instanceOfWorkingTimeCosts(value: object): value is WorkingTimeCosts {
    if (!('workingTimeCosts' in value) || value['workingTimeCosts'] === undefined) return false;
    return true;
}

export function WorkingTimeCostsFromJSON(json: any): WorkingTimeCosts {
    return WorkingTimeCostsFromJSONTyped(json, false);
}

export function WorkingTimeCostsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkingTimeCosts {
    if (json == null) {
        return json;
    }
    return {
        
        'workingTimeCosts': ((json['workingTimeCosts'] as Array<any>).map(WorkingTimeCostFromJSON)),
    };
}

  export function WorkingTimeCostsToJSON(json: any): WorkingTimeCosts {
      return WorkingTimeCostsToJSONTyped(json, false);
  }

  export function WorkingTimeCostsToJSONTyped(value?: WorkingTimeCosts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workingTimeCosts': ((value['workingTimeCosts'] as Array<any>).map(WorkingTimeCostToJSON)),
    };
}

